@if (users?.length > 0) {
  <div
    class="avatars cursor-pointer"
    (click)="peopleClicked.emit($event)">
    @for (user of users | slice: 0 : maxLength; track user.id) {
      <div
        class="avatar-image avatars__avatar"
        [avatar]="{ user: user, size: 'small', imgSize: '36px' }"></div>
    }
    @if (users.length > maxLength || users.length < count) {
      <div class="avatar-image avatars__avatar avatars__counter">
        <small class="avatars__other"
          >+{{
            !!maxLength && !!count ? count - maxLength : !!count ? count - users.length : users.length - maxLength
          }}</small
        >
      </div>
    }
  </div>
}
